import { FOCUS_RING, Icon } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

interface ValueStepperProps {
    onIncrease: () => void;
    onDecrease: () => void;
    disabled?: boolean;
    /** `data-testid` stem; the buttons expose `<stem>-increase` and `<stem>-decrease`. */
    dataTestIdPrefix: string;
}

const BUTTON_CLASS = 'flex items-center justify-center rounded-[4px] hover:opacity-80';

/**
 * The two chevrons of the prototype's `NumericValueInput`. No library input ships that chrome, so
 * both the form's key-result rows and the detail page's progress control compose it from these
 * buttons. `obj-value-stepper` (app.css) carries their geometry at both widths: a 44px touch
 * target side by side on a phone, the compact 28x24 stack above it.
 */
export default function ValueStepper({
    onIncrease,
    onDecrease,
    disabled,
    dataTestIdPrefix,
}: ValueStepperProps) {
    const { t } = useTranslation();

    return (
        <div className={'obj-value-stepper'}>
            <button
                type={'button'}
                onClick={onIncrease}
                disabled={disabled}
                aria-label={t('objectives.form.increaseValue')}
                className={`${BUTTON_CLASS} ${FOCUS_RING} bg-obj-stepper`}
                data-testid={`${dataTestIdPrefix}-increase`}
            >
                <Icon
                    name={'arrow-arrow-up-1'}
                    size={16}
                    colorClassName={'text-navy'}
                />
            </button>

            <button
                type={'button'}
                onClick={onDecrease}
                disabled={disabled}
                aria-label={t('objectives.form.decreaseValue')}
                className={`${BUTTON_CLASS} ${FOCUS_RING} bg-obj-line`}
                data-testid={`${dataTestIdPrefix}-decrease`}
            >
                <Icon
                    name={'arrow-arrow-down'}
                    size={16}
                    colorClassName={'text-obj-muted'}
                />
            </button>
        </div>
    );
}
